import {environment} from '../../config/environment';
import {api} from '../../shared/utils';
import {SISTEMAS_CONFIG} from './sistemasConfig';

const baseUrl = environment.apiBaseURLClients;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

export const listCatalogEntity = (entityKey, params = {}) => {
    const query = buildQuery(params);
    const url = `${baseUrl}${SISTEMAS_CONFIG[entityKey].endpoint}${query ? `?${query}` : ''}`;
    return api.get(url);
};
